import React from 'react';
import Disclaimer from 'components/common/general/Disclaimer';
import CartContent from 'components/cart/CartContent';
import { createStyles } from '../../globalStyles';

const CartPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.pageWrapper}>
      <CartContent />
      <Disclaimer />
    </div>
  );
};

export default CartPage;
